import { atom } from 'jotai';

import { Maybe } from '@/types';
import { TapAtomState } from '@/types/tda';

export const tapDataAtom = atom<Maybe<TapAtomState>>({});
